import { configureStore } from "@reduxjs/toolkit";
import notificationReducer from "./slices/notificationSlice";
import roleReducer from "./slices/roleSlice";
import statsReducer from "./slices/statsSlice";

export const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    roles: roleReducer,
    stats: statsReducer,
  },
});
